import { render, staticRenderFns } from "./StatisticsPanel.vue?vue&type=template&id=498a7248&scoped=true&"
import script from "./StatisticsPanel.vue?vue&type=script&lang=js&"
export * from "./StatisticsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498a7248",
  null
  
)

export default component.exports